export const USER_SETTINGS_UPDATE_PREFIX = 'USER/SETTINGS_UPDATE_';

export const USER_SETTINGS_MAP_DROPDOWN_UPDATE = `${USER_SETTINGS_UPDATE_PREFIX}MAP_DROPDOWN`;
export const USER_SETTINGS_THEME_UPDATE = `${USER_SETTINGS_UPDATE_PREFIX}THEME`;

export const USER_SETTINGS_SPLIT_PANEL_CLOSE = `${USER_SETTINGS_UPDATE_PREFIX}SPLIT_PANEL_CLOSE`;
export const USER_SETTINGS_SPLIT_PANEL_OPEN = `${USER_SETTINGS_UPDATE_PREFIX}SPLIT_PANEL_OPEN`;

export const USER_SETTINGS_SET_TOOL_COLLAPSE = `${USER_SETTINGS_UPDATE_PREFIX}SET_TOOL_COLLAPSE`;

export const USER_SETTINGS_SYNC_REQUEST = 'USER/SETTINGS_SYNC_REQUEST';
export const USER_SETTINGS_SYNC_SUCCESS = 'USER/SETTINGS_SYNC_SUCCESS';
export const USER_SETTINGS_SYNC_FAIL = 'USER/SETTINGS_SYNC_FAIL';
